import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";

const SummaryCard = ({
    title,
    titleTag,
    titleClassName,
    children,
    cardProps,
    cardBodyProps,
    cardTextProps,
    cardClass
}) => {
    return (
        <Card {...cardProps} className={`custom-card ${cardClass}`}>
            <CardBody {...cardBodyProps}>
                {title && (
                    <CardTitle tag={titleTag} className={titleClassName}>
                        {title}
                    </CardTitle>
                )}
                <CardText {...cardTextProps}>{children}</CardText>
            </CardBody>
        </Card>
    );
};

SummaryCard.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleTag: PropTypes.string,
    titleClassName: PropTypes.string,
    cardClass: PropTypes.string,
    children: PropTypes.node.isRequired,
    cardProps: PropTypes.object,
    cardBodyProps: PropTypes.object,
    cardTextProps: PropTypes.object
};

SummaryCard.defaultProps = {
    title: null,
    titleTag: "h3",
    cardClass: "",
    titleClassName: "mb-0",
    cardProps: { className: "p-2" },
    cardBodyProps: { className: "p-0" },
    cardTextProps: {}
};

export default SummaryCard;
